export default __webpack_public_path__ + "static/home-slide-small004-d1496b3f6abfc9d11a3fb421f2edeaf9.jpg";